const letters = [
  'A', 'B', 'C', 'D', 'E',
  'F', 'G', 'H', 'I', 'J',
  'K', 'L', 'M', 'N', 'O',
  'P', 'Q', 'R', 'S', 'T',
  'U', 'V', 'W', 'X', 'Y',
  'Z'
]

export default (y) => {
  const offset = y % letters.length
  const firstCharIndex = Math.floor((y - offset) / letters.length)
  return letters[firstCharIndex] + letters[offset]
}
